<template>
    <div>
        <div class="w-full lg:w-[90%] pt-10  mx-auto flex justify-between items-center">
            <div class="flex items-center w-[50%] gap-2">
                <button @click="handlegoback"
                    class="px-2 py-1 hover:border hover:border-gray-300 bg-transparent rounded-md transition">
                    <img src="@/assets/images/icons/arrows/left-angle.svg" alt="">
                </button>
                <h2 class="font-mulish text-2xl text-[#053A51] text-left font-bold">
                    Batch name
                </h2>
            </div>
            <div v-if="batch && batch.approvalStatus !== 'approved' && batch.approvalStatus !== 'rejected'"
                class="w-[50%] flex justify-end items-end gap-3 mb-4 pt-4">
                <button type="button" @click="approvePromotion('approved')"
                    class="lg:w-[143] w-auto h-[56px] px-4 py-2 rounded-lg bg-[#1A8103] text-white text-base hover:bg-[#265c19]">
                    Approve
                </button>
                <button type="button" @click="approvePromotion('rejected')"
                    class="lg:w-[143] w-auto h-[56px] px-4 py-2 rounded-lg border bg-[#FFECEC] text-[#FF0000] text-base hover:bg-[#b9b5b5]">
                    Reject
                </button>
            </div>
        </div>
        <div class="w-full lg:w-[90%] px-4 lg:px-0  mx-auto rounded-lg py-4">
            <div class="overflow-x-auto px-4">
                <api-table :apiUrl="`/staff-promotion/batch/${batchId}/items`" :fields="fields" :show-page="true"
                    :show-search="true" placeholder="Search by name, phone number or email">
                    <template slot="validationStatus" slot-scope="props">
                        <span v-if="
                            props.rowData.validationStatus === 'pending'
                        " class="text-gray-500 font-bold capitalize">
                            Pending
                        </span>
                        <span v-else class="text-oneGreen font-bold capitalize">
                            {{ props.rowData.validationStatus }}
                        </span>
                    </template>
                    <template slot="action" slot-scope="props">
                        <span v-if="props.rowData.approvalStatus === 'approved'"
                            class="flex gap-2 justify-end items-center pr-2">
                            <button @click="viewGen(props.rowData)"
                                class="px-3 py-1 bg-[#187A33] text-sm font-mulish font-semibold text-[#fff] rounded-md transition">
                                View
                            </button>
                        </span>
                    </template>
                </api-table>
            </div>
        </div>
        <ActionModal :open="openGen" @close="openGen = false">
            <template #content>
                <section id="genPrintout">
                    <PromotionPrintout :staff-data="staffData" :getting="getting" />
                </section>
            </template>

            <template #action>
                <!-- <button class="bg-[#FFECEC] text-sm p-3 rounded-lg">Reject</button> -->

                <button v-can="'sign-gen69'" v-if="staffData && staffData.signatureStatus === 'requested'"
                    @click="sendOtp()" :disabled="sending"
                    class="bg-oneGreen text-sm p-3 rounded-lg text-white flex gap-2 justify-center">
                    <span>Sign</span>
                    <spinner v-if="sending" class="w-5 h-5"></spinner>
                </button>

                <button v-if="staffData" @click="printOutGen" class="bg-idBlued text-sm p-3 rounded-lg text-white">
                    Print
                </button>
            </template>
        </ActionModal>

        <modal v-model="openToken" v-if="openToken">
            <TokenVerify @token="signGen" @resend="sendOtp" :resending="sending" :processing="signning"
                :message="otpMessage" />
        </modal>
    </div>
</template>

<script>
import ActionModal from "@/components/admin/records/ActionModal.vue";
import PromotionPrintout from "./PromotionPrintout.vue";
import TokenVerify from "@/components/admin/signature/TokenVerify.vue";
export default {
    name: "BatchPromotionItems",
    components: {
        ActionModal,
        PromotionPrintout,
        TokenVerify,
    },
    data() {
        return {
            openGen: false,
            openToken: false,
            getting: false,
            sending: false,
            signning: false,
            staffData: {},
            otpMessage: null,
            batch: null,
            currentPage: 1,
            perPage: 5,
            fields: [
                {
                    name: "id",
                    title: "S/N",
                    titleClass: `text-left bg-[#DEFFDE] py-3 pl-4 `,
                    dataClass: `text-left py-2 pl-4`,
                },
                {
                    name: "verificationCode",
                    title: "Verification No.",
                    titleClass: `text-left bg-[#DEFFDE] py-3 pl-4 `,
                    dataClass: `text-left py-2 pl-4`,
                },
                {
                    name: "fullName",
                    title: "Full name",
                    titleClass: `text-left bg-[#DEFFDE] py-3 pl-4 `,
                    dataClass: `text-left py-2 pl-4 capitalize`,
                },
                {
                    name: "stateId",
                    title: "State ID",
                    titleClass: `text-left bg-[#DEFFDE] py-3 pl-4 `,
                    dataClass: `text-left py-2 pl-4`,
                },
                {
                    name: "mdaName",
                    title: "MDA",
                    titleClass: `text-left bg-[#DEFFDE] py-3 pl-4 `,
                    dataClass: `text-left py-2 pl-4 capitalize`,
                },
                {
                    name: "departmentName",
                    title: "Department",
                    titleClass: `text-left bg-[#DEFFDE] py-3 pl-4 `,
                    dataClass: `text-left py-2 pl-4 capitalize`,
                },
                {
                    name: "fromGradeLevel",
                    title: "Grade From",
                    titleClass: `text-left bg-[#DEFFDE] py-3 pl-4 `,
                    dataClass: `text-left py-2 pl-4`,
                },
                {
                    name: "toGradeLevel",
                    title: "Grade To",
                    titleClass: `text-left bg-[#DEFFDE] py-3 pl-4 `,
                    dataClass: `text-left py-2 pl-4`,
                },
                {
                    name: "fromStep",
                    title: "Step From",
                    titleClass: `text-left bg-[#DEFFDE] py-3 pl-4 `,
                    dataClass: `text-left py-2 pl-4`,
                },
                {
                    name: "toStep",
                    title: "Step To",
                    titleClass: `text-left bg-[#DEFFDE] py-3 pl-4 `,
                    dataClass: `text-left py-2 pl-4`,
                },
                {
                    name: "createdAt",
                    title: "Date of Promotion",
                    titleClass: `text-left bg-[#DEFFDE] py-3 pl-4 `,
                    dataClass: `text-left py-2 pl-4`,
                    formatter: (val) =>
                        !val ? val : this.moment(val).format("DD-MM-YYYY"),
                },
                {
                    name: "action",
                    title: "Action",
                    titleClass: ` text-center bg-[#DEFFDE] py-3 pl-4 `,
                    dataClass: `text-left py-2 pl-4`,
                },
            ],
        };
    },
    computed: {
        batchId() {
            return this.$route.params.id;
        }
    },
    mounted() {
        this.fetchBatch();
    },
    methods: {
        async viewGen(dt) {
            this.openGen = true;
            this.staffData = dt;
        },
        async fetchBatch() {
            try {
                const res = await this.$http.get(`/staff-promotion/batch/${this.batchId}`);
                this.batch = res.data.data;
            } catch (error) {
                console.error(error);
            }
        },
        handlegoback() {
            this.$router.push("/admin/promotion/batch-records");
        },
        async approvePromotion(status) {
            try {
                let payload = {
                    baseUrl: `${window.location.origin}/promotion-certificate}`,
                    markStatus: status,
                };

                //  If approving, show confirmation
                if (status === "approved") {
                    const confirm = await this.$swal({
                        title: "Are you sure?",
                        text: "You are about to approve this promotion batch.",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#1A8103",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Yes, Approve!",
                    });

                    if (!confirm.isConfirmed) return;
                }

                // 🔹 If rejecting, ask for reason
                if (status === "rejected") {
                    const { value: reason } = await this.$swal({
                        title: "Reason for Rejection",
                        input: "textarea",
                        inputPlaceholder: "Enter reason...",
                        inputAttributes: {
                            "aria-label": "Enter reason for rejection",
                        },
                        showCancelButton: true,
                        confirmButtonText: "Submit",
                    });

                    if (!reason) {
                        return;
                    }

                    payload.rejectedReason = reason;
                }

                // 🔹 Send request
                this.requesting = true;
                const res = await this.$http.put(
                    `/staff-promotion/mark-batch/${this.batchId}`,
                    payload
                );
                this.requesting = false;

                if (!res) return;

                const { data } = res;
                this.fetchBatch();
                await this.$swal({
                    icon: "success",
                    text: data.message,
                });

                this.$events.fire("table-refresh");
            } catch (error) {
                this.requesting = false;
                this.$swal({
                    icon: "error",
                    text: "An error occurred while processing your request.",
                });
            }
        },

        printOutGen() {
            const mywindow = window.open("", "", "");
            const divContents = document.getElementById("genPrintout").innerHTML;
            mywindow.document.write("<html><head><title></title>");
            mywindow.document.write(
                ' <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/tailwindcss/2.2.19/tailwind.min.css">'
            );
            mywindow.document.write("</head><body>");

            const links = document.querySelectorAll("style");
            links.forEach(function (link) {
                mywindow.document.head.appendChild(link.cloneNode(true));
            });

            mywindow.document.write(divContents);
            mywindow.document.write("</body></html>");
            mywindow.document.close();
            mywindow.focus();
            setTimeout(() => {
                mywindow.print();
                mywindow.close();
                return true;
            }, 1000);
        },

    }

};
</script>
